import React from "react";

interface ModeRendererProps {
  brand: string;
  today: string;
  Copy: string;
}

export function VasarelyBouyguesMode({ brand }: ModeRendererProps) {
  const width = 794;
  const height = 1123;

  const bgGradient = (
    <defs>
      <linearGradient id="bouyguesGradient" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" style={{ stopColor: "#004890", stopOpacity: 1 }} />
        <stop offset="50%" style={{ stopColor: "#0066B3", stopOpacity: 1 }} />
        <stop offset="100%" style={{ stopColor: "#E74C3C", stopOpacity: 0.2 }} />
      </linearGradient>
    </defs>
  );

  // Urban blocks - city planning grid
  const urbanBlocks: JSX.Element[] = [];
  const blocksX = 12;
  const blocksY = 16;
  const blockW = 55;
  const blockH = 65;
  
  for (let i = 0; i < blocksX; i++) {
    for (let j = 0; j < blocksY; j++) {
      const x = -330 + i * blockW;
      const y = -520 + j * blockH;
      const hasBuilding = Math.random() > 0.3;
      
      if (hasBuilding) {
        urbanBlocks.push(
          <rect
            key={`block-${i}-${j}`}
            x={x}
            y={y}
            width={blockW - 8}
            height={blockH - 8}
            fill="none"
            stroke="#FFFFFF"
            strokeWidth={2}
            opacity={0.2}
            rx={4}
          />
        );
      }
    }
  }

  // Construction grids - structural frameworks
  const constructionGrids: JSX.Element[] = [];
  for (let layer = 0; layer < 14; layer++) {
    const size = 120 + layer * 35;
    
    constructionGrids.push(
      <rect
        key={`grid-${layer}`}
        x={-size / 2}
        y={-size / 2}
        width={size}
        height={size}
        fill="none"
        stroke="#0066B3"
        strokeWidth={layer % 3 === 0 ? 2.5 : 1.5}
        opacity={0.3 - layer * 0.015}
        rx={6}
      />
    );
  }

  // Structural lattices - support beams
  const latticeLines: JSX.Element[] = [];
  for (let beam = 0; beam < 24; beam++) {
    const angle = (beam / 24) * 2 * Math.PI;
    const x = Math.cos(angle) * 380;
    const y = Math.sin(angle) * 380;
    
    latticeLines.push(
      <line
        key={`beam-${beam}`}
        x1={0}
        y1={0}
        x2={x}
        y2={y}
        stroke="#FFFFFF"
        strokeWidth={beam % 4 === 0 ? 2 : 1}
        opacity={beam % 4 === 0 ? 0.3 : 0.15}
        strokeDasharray="8,4"
      />
    );
  }

  // Infrastructure nodes
  const infrastructureNodes: JSX.Element[] = [];
  const nodeRing = [160, 260, 340];
  
  nodeRing.forEach((r, ri) => {
    const count = 6 + ri * 2;
    for (let n = 0; n < count; n++) {
      const angle = (n / count) * 2 * Math.PI;
      const nx = Math.cos(angle) * r;
      const ny = Math.sin(angle) * r;
      
      infrastructureNodes.push(
        <g key={`infra-${ri}-${n}`}>
          <rect
            x={nx - 20}
            y={ny - 20}
            width={40}
            height={40}
            fill="none"
            stroke="#E74C3C"
            strokeWidth={2}
            opacity={0.4}
            rx={4}
          />
          <circle cx={nx} cy={ny} r={10} fill="#0066B3" opacity={0.5} />
        </g>
      );
    }
  });

  return (
    <svg width={width} height={height} xmlns="http://www.w3.org/2000/svg">
      {bgGradient}
      <rect width={width} height={height} fill="url(#bouyguesGradient)" />
      <g transform={`translate(${width / 2}, ${height / 2})`}>
        {urbanBlocks}
        {latticeLines}
        {constructionGrids}
        {infrastructureNodes}
        <rect x={-45} y={-45} width={90} height={90} fill="none" stroke="#FFFFFF" strokeWidth={3} opacity={0.6} rx={6} />
        <rect x={-30} y={-30} width={60} height={60} fill="#0066B3" opacity={0.3} rx={4} />
      </g>
    </svg>
  );
};
